import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA} from '@angular/material/dialog';


@Component({
    selector: 'app-view-contract-modal',
    templateUrl: './view-contract-modal.component.html',
    styleUrls: ['./view-contract-modal.component.css'],
    standalone: false
})
export class ViewContractModalComponent implements OnInit {

  linkToContract?: string;

  linkToPdfContract: any;
  attachmentObject: any;

  constructor(public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) data) {

    if (data.linkToContract) {
      this.linkToContract = data.linkToContract;
    }

    this.attachmentObject = data.linkToPdf;

  }

  async ngOnInit() {

    // if (!this.attachmentObject) {
    //   this.linkToPdfContract = await this.attachmentService.processMainContractFileAttachment(this.linkToContract);
    // } else {
    //   this.linkToPdfContract = this.attachmentObject;
    //   this.linkToPdfContract.safePdfHtml = this.attachmentObject.showPdfSafeHtml;
    // }

  }

}
